var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.CardList, function (cardDetails) {
      return cardDetails.hasPermission
        ? _c(
            "b-card",
            { key: cardDetails.section },
            [
              _c(
                "b-card-header",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle",
                      value: cardDetails.section,
                      expression: "cardDetails.section",
                    },
                  ],
                  class: { collapsed: cardDetails.collapse },
                  attrs: {
                    "aria-expanded": cardDetails.collapse ? "true" : "false",
                    "aria-controls": cardDetails.section,
                    role: "tab",
                    "data-toggle": "collapse",
                  },
                },
                [
                  _vm._v(" " + _vm._s(cardDetails.name) + " "),
                  !cardDetails.collapse
                    ? _c("feather-icon", { attrs: { icon: "ChevronDownIcon" } })
                    : _c("feather-icon", { attrs: { icon: "ChevronUpIcon" } }),
                ],
                1
              ),
              _c(
                "b-collapse",
                {
                  staticClass: "card-content",
                  attrs: {
                    visible: cardDetails.visible,
                    id: cardDetails.section,
                  },
                  model: {
                    value: cardDetails.collapse,
                    callback: function ($$v) {
                      _vm.$set(cardDetails, "collapse", $$v)
                    },
                    expression: "cardDetails.collapse",
                  },
                },
                [
                  _c(
                    "b-card-body",
                    [
                      _c("CustomFields", {
                        attrs: { ModuleReference: cardDetails.section },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e()
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }